import { render, staticRenderFns } from "./cmm-image.vue?vue&type=template&id=685a8156&"
import script from "./cmm-image.vue?vue&type=script&lang=js&"
export * from "./cmm-image.vue?vue&type=script&lang=js&"
import style0 from "./cmm-image.vue?vue&type=style&index=0&id=685a8156&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports